/* Scala lightbox: one shared, navigable photo viewer per page.
   Items:   any element with [data-lb] and data-lb-src (optional data-lb-alt, data-lb-group, default "page").
   Openers: any element with [data-lb-open="group"] opens that group at the first photo.
   [data-lb-count="group"] elements get the number of photos in that group. */
(function () {
  if (window.__sbLightbox) return;
  window.__sbLightbox = true;

  var dlg, img, counter, items = [], index = 0, lastFocus = null, touchX = null;

  function keyOf(src) { return (src || '').split('?')[0]; }

  /* Shopify CDN resizes on the fly: swap the width parameter */
  function sized(src, w) {
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fullWidth() {
    var w = Math.max(window.innerWidth, window.innerHeight) * Math.min(window.devicePixelRatio || 1, 2);
    return Math.min(2000, Math.max(800, Math.ceil(w / 200) * 200));
  }
  var PREVIEW_W = 480, cache = {};
  function load(url, cb) {
    if (cache[url] === true) { if (cb) cb(); return; }
    var im = new Image();
    im.decoding = 'async';
    im.onload = function () { cache[url] = true; if (cb) cb(); };
    im.src = url;
  }

  function collect(group) {
    var seen = {}, out = [];
    document.querySelectorAll('[data-lb]').forEach(function (el) {
      if ((el.getAttribute('data-lb-group') || 'page') !== group) return;
      var src = el.getAttribute('data-lb-src'); var k = keyOf(src);
      if (!src || seen[k]) return;
      seen[k] = true;
      var thumb = el.querySelector && el.querySelector('img');
      out.push({ src: src, alt: el.getAttribute('data-lb-alt') || '', el: el,
        preview: sized(src, PREVIEW_W), full: sized(src, fullWidth()),
        thumb: thumb && thumb.complete && thumb.currentSrc ? thumb.currentSrc : null });
    });
    return out;
  }

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'sb-lb';
    dlg.setAttribute('aria-label', 'Photos');
    dlg.innerHTML =
      '<div class="sb-lb__stage"><img class="sb-lb__img" alt=""></div>' +
      '<button type="button" class="sb-lb__btn sb-lb__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="sb-lb__btn sb-lb__prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="sb-lb__btn sb-lb__next" aria-label="Next photo">&#8250;</button>' +
      '<p class="sb-lb__count" aria-live="polite"></p>';
    document.body.appendChild(dlg);
    img = dlg.querySelector('.sb-lb__img');
    counter = dlg.querySelector('.sb-lb__count');
    dlg.querySelector('.sb-lb__close').addEventListener('click', close);
    dlg.querySelector('.sb-lb__prev').addEventListener('click', function () { go(-1); });
    dlg.querySelector('.sb-lb__next').addEventListener('click', function () { go(1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.classList.contains('sb-lb__stage')) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('sb-lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
    dlg.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX; touchX = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });
  }

  function show(i) {
    index = (i + items.length) % items.length;
    var it = items[index], my = index;
    img.alt = it.alt;
    counter.textContent = (index + 1) + ' / ' + items.length;
    var multi = items.length > 1;
    dlg.querySelector('.sb-lb__prev').hidden = !multi;
    dlg.querySelector('.sb-lb__next').hidden = !multi;
    if (cache[it.full] === true) {
      img.src = it.full; img.classList.remove('is-preview');
    } else {
      /* Instant low-res: the thumbnail already on the page, or a small preview */
      img.src = it.thumb || it.preview;
      img.classList.add('is-preview');
      load(it.full, function () {
        if (index !== my) return;
        img.src = it.full; img.classList.remove('is-preview');
        warm();
      });
    }
    if (cache[it.full] === true) warm();
  }

  /* After the current photo, fetch neighbours in full size */
  function warm() {
    [1, -1, 2].forEach(function (d) {
      var n = items[(index + d + items.length) % items.length];
      if (n) load(n.full);
    });
  }

  function go(d) { if (items.length) show(index + d); }

  function open(group, startEl) {
    items = collect(group);
    if (!items.length) return;
    if (!dlg) build();
    var start = 0;
    if (startEl) {
      var k = keyOf(startEl.getAttribute('data-lb-src'));
      items.forEach(function (it, i) { if (keyOf(it.src) === k) start = i; });
    }
    lastFocus = document.activeElement;
    items.forEach(function (it) { load(it.preview); });
    show(start);
    document.documentElement.classList.add('sb-lb-open');
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function close() { if (dlg.open) dlg.close(); else dlg.removeAttribute('open'); }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lb-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-lb-open')); return; }
    var item = e.target.closest('[data-lb]');
    if (item && !item.hidden) { e.preventDefault(); open(item.getAttribute('data-lb-group') || 'page', item); }
  });

  function counts() {
    document.querySelectorAll('[data-lb-count]').forEach(function (el) {
      el.textContent = collect(el.getAttribute('data-lb-count')).length;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', counts); else counts();
})();
